// extracted by mini-css-extract-plugin
export default {"loader":"styles-module_loader_S9H00o","spin":"styles-module_spin_FP1x6V","wrapper":"styles-module_wrapper_h3IvQr"};